<template>
    <div id="dashboard">
       <nav class="navbar is-dark is-fixed-top">
            <div class="column is-10-fullhd is-offset-1-fullhd is-12-mobile is-12-tablet is-paddingless">
                <nav class="navbar is-transparent">
                    <div class="navbar-brand">
                        <router-link class="navbar-item" to="/dashboard/comments">
                            <img class="logo is-paddingless" v-bind:src="'/static/img/transparent.png'">
                            <section class="hero is-hidden-touch is-hidden-desktop-only">
                                <div class="hero-body">
                                    <div class="">
                                        <h1 class="title has-text-primary">
                                            <img class="header" v-bind:src="'/static/img/header.png'">
                                        </h1>
    <!--                                    <h2 class="subtitle">
                                            Online ESL Feedback Assistant
                                        </h2>-->
                                    </div>
                                </div>
                            </section>
                        </router-link>
                        <div class="navbar-burger burger is-hidden-desktop" data-target="navbar-mobile">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>

                    <div v-if="me.id != -1" id="navbar-mobile" class="navbar-menu is-dark is-hidden-desktop">
                        <a @click="redirectTo('/dashboard/comments')" class="navbar-item" href="javascript:{}"v-if="me.id != -1 && me.subscription && !me.subscription.expired">
                            <i class="fa fa-pencil-alt"></i> New Feedback
                        </a>
                        <div class="navbar-item has-dropdown" v-if="me.id != -1 && me.subscription && !me.subscription.expired">
                            <router-link class="navbar-link" to="/dashboard/sentences">
                                <i class="fa fa-list"></i> My sets
                            </router-link>

                            <div class="navbar-dropdown">
                                <a @click="redirectTo('/dashboard/sentences')" class="navbar-item" href="javascript:{}">
                                    Sentences
                                </a>
                                <a @click="redirectTo('/dashboard/categories')" class="navbar-item" href="javascript:{}">
                                    Categories
                                </a>
                            </div>
                        </div>

                        <a target="_blank" href="https://chrome.google.com/webstore/detail/blabla-commentz-official/pdmlpflicmifcajjohipcoohalannboc" class="navbar-item">
                            <span data-badge="NEW" class="is-badge-danger is-badge-small badge">
                                <i class="fa fa-puzzle-piece bell-shake-delay" ></i> Extension
                            </span>
                        </a>

<!--                        <a target="_blank" href="https://calendly.com/blabla_commentz/blabla-training-with-debbie" class="navbar-item">
                            <i class="fa fa-question-circle"></i> Schedule Training
                        </a>-->

                        <a @click="redirectTo('/dashboard/stats')" class="navbar-item" href="javascript:{}" v-if="me.id != -1 && me.subscription && !me.subscription.expired">
                            <i class="fa fa-chart-line"></i> Achievements
                        </a>

                        <a class="navbar-item" @click="redirectTo('/dashboard/news')" href="javascript:{}" v-if="me.id != -1 && me.subscription && !me.subscription.expired">
                            <span v-bind:data-badge="news.length" :class="{ 'is-badge-danger is-badge-small badge': news.length > 0}">
                                <i class="fa fa-bell" :class="{ 'bell-shake-delay': news.length > 0}" ></i> News
                            </span>
                        </a>

                        <a @click="redirectTo('/dashboard/profile')" class="navbar-item" href="javascript:{}">
                            <i class="fa fa-user"></i> Profile
                        </a>
                        <a v-if="hasMEAsSchool" @click="redirectTo('/stby/me')" class="navbar-item" href="javascript:{}">
                            <i class="fa fa-gift"></i> Magic Ears StandBy LifeSaver 2.0
                        </a>
                        <a target="_blank" href="https://shop.spreadshirt.com/blabla-commentz-shop/" class="navbar-item">
                            <i class="fa fa-shopping-bag"></i> Shop
                        </a>

<!--                        <a v-if="hasVKAsSchool" @click="redirectTo('/stby/vk')" class="navbar-item" href="javascript:{}">-->
<!--                            <i class="fa fa-gift"></i> VIPKID Collaborative Lesson Bank-->
<!--                        </a>-->

                        <a @click="redirectTo('/dashboard/ticket')" class="navbar-item" href="javascript:{}">
                            Contact us
                        </a>

                        <a @click="redirectTo('/dashboard/terms')" class="navbar-item" href="javascript:{}">
                            Terms and Conditions
                        </a>

                        <a @click="redirectTo('/dashboard/privacy')" class="navbar-item" href="javascript:{}">
                            Privacy policy
                        </a>

<!--                        <div class="navbar-item has-dropdown">
                            <router-link class="navbar-link" to="">
                                <i class="fa fa-question-circle"></i> How to
                            </router-link>
                            <div class="navbar-dropdown">
                                <a @click.native="closeMenu" class="navbar-item" href="https://www.youtube.com/watch?v=b2OsTXGW7TM" target="_blank">
                                    Add New Sentences
                                </a>
                                <hr class="navbar-divider">
                                <a @click.native="closeMenu" class="navbar-item" href="https://www.youtube.com/watch?v=KH9pCgJ0RYU" target="_blank">
                                    Create New Category / Change Color
                                </a>
                                <hr class="navbar-divider">
                                <a @click.native="closeMenu" class="navbar-item" href="https://www.youtube.com/watch?v=dUwLlS7_5p0" target="_blank">
                                    Change Avatar / Choose School
                                </a>
                                <hr class="navbar-divider">
                                <a @click.native="closeMenu" class="navbar-item" href="https://www.youtube.com/watch?v=EF1n8Xl5WG8" target="_blank">
                                    Generate New Feedback
                                </a>
                                <hr class="navbar-divider">
                                <a @click.native="closeMenu" class="navbar-item" href="https://www.youtube.com/watch?v=OF4U1XHx2M4" target="_blank">
                                    Contact Us / Submit Ticket
                                </a>
                            </div>
                        </div>
    -->


                        <a href="javascript:{}" class="navbar-item" @click="logout">
                            <i class="fa fa-power-off"></i> Logout
                        </a>
                        <div class="columns">
                            <div class="column has-text-centered">
                                <a href="https://www.facebook.com/BlaBla-Commentz-ESL-Feedback-Assistant-100642284743216/" target="_blank" ><i class="icon-facebook fab fa-facebook-f fa-2x" aria-hidden="true"></i></a>
                                <a href="https://twitter.com/BlaBla_Commentz" target="_blank" ><i class="icon-twitter fab fa-twitter fa-2x" aria-hidden="true"></i></a>
                                <a href="https://www.instagram.com/blablacommentz/" target="_blank" ><i class="icon-instagram fab fa-instagram fa-2x" aria-hidden="true"></i></a>
                                <a href="https://www.youtube.com/channel/UCuxsSXR2N_QoxXvdbHYqvgQ" target="_blank" ><i class="icon-youtube fab fa-youtube fa-2x" aria-hidden="true"></i></a>
                            </div>
                        </div>
                    </div>

                    <div v-if="isSTBY && (me.id == -1 || me.id == null)" id="navbar-mobile" class="navbar-menu is-dark is-hidden-desktop" style="background-color: transparent;">
                        <div class="navbar-item" style="text-align: right;">
                            <div class="buttons">
                                <a href="/login" class="button is-rounded">
                                    I already have an account
                                </a>
                                <a href="/register" class="button is-primary is-rounded">
                                    Sign up for Feedback Assistant
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="navbar-menu">
                        <div class="navbar-start">
                        </div>

                        <div  v-if="me.id != -1" class="navbar-end">

<!--
                            <div class="navbar-item has-dropdown is-hoverable">
                                <router-link class="navbar-link" to="">
                                    <div class="level-item has-text-centered">
                                        <div>
                                            <p class="heading"><i class="fa fa-2x fa-question-circle"></i></p>
                                            <p class="heading">How to</p>
                                        </div>
                                    </div>
                                </router-link>
                                <div class="navbar-dropdown">
                                    <a class="navbar-item" href="https://www.youtube.com/watch?v=b2OsTXGW7TM" target="_blank">
                                        Add New Sentences
                                    </a>
                                    <hr class="navbar-divider">
                                    <a class="navbar-item" href="https://www.youtube.com/watch?v=KH9pCgJ0RYU" target="_blank">
                                        Create New Category / Change Color
                                    </a>
                                    <hr class="navbar-divider">
                                    <a class="navbar-item" href="https://www.youtube.com/watch?v=dUwLlS7_5p0" target="_blank">
                                        Change Avatar / Choose School
                                    </a>
                                    <hr class="navbar-divider">
                                    <a class="navbar-item" href="https://www.youtube.com/watch?v=EF1n8Xl5WG8" target="_blank">
                                        Generate New Feedback
                                    </a>
                                    <hr class="navbar-divider">
                                    <a class="navbar-item" href="https://www.youtube.com/watch?v=OF4U1XHx2M4" target="_blank">
                                        Contact Us / Submit Ticket
                                    </a>
                                </div>
                            </div>
    -->


                           <!-- <a target="_blank" class="navbar-item" href="https://calendly.com/blabla_commentz/blabla-training-with-debbie">
                                <div class="level-item has-text-centered">
                                    <div>
                                        <p class="heading" >
                                            <i  class="fa fa-2x fa-calendar-check"></i>
                                        </p>
                                        <p class="heading ">Schedule Training</p>
                                    </div>
                                </div>
                            </a>-->

                            <a target="_blank" class="navbar-item" href="https://chrome.google.com/webstore/detail/blabla-commentz-official/pdmlpflicmifcajjohipcoohalannboc">
                                <div class="level-item has-text-centered">
                                    <span  data-badge="NEW" class="is-badge-danger is-badge-small badge">
                                        <p class="heading" >
                                            <i  class="fa fa-2x fa-puzzle-piece bell-shake-delay"></i>
                                        </p>
                                        <p class="heading ">Extension</p>
                                    </span>
                                </div>
                            </a>

                            <router-link v-if="me.id != -1 && me.subscription && !me.subscription.expired" class="navbar-item" v-bind:class="{'is-selected' : routeMatch('/dashboard/comments')}" to="/dashboard/comments">
                                <div class="level-item has-text-centered">
                                    <div>
                                        <p class="heading"><i class="fa fa-2x fa-pencil-alt"></i></p>
                                        <p class="heading">New Feedback</p>
                                    </div>
                                </div>
                            </router-link>

                            <div v-if="me.id != -1 && me.subscription && !me.subscription.expired" class="navbar-item has-dropdown is-hoverable" v-bind:class="{'is-selected' : routeMatch('/dashboard/categories') || routeMatch('/dashboard/sentences')}">
                                <router-link class="navbar-link" to="/dashboard/sentences">
                                    <div class="level-item has-text-centered">
                                        <div>
                                            <p class="heading"><i class="fa fa-2x fa-list"></i></p>
                                            <p class="heading">My Sets</p>
                                        </div>
                                    </div>
                                </router-link>
                                <div class="navbar-dropdown">
                                    <router-link class="navbar-item" to="/dashboard/sentences">
                                        Sentences
                                    </router-link>
                                    <router-link class="navbar-item" to="/dashboard/categories">
                                        Categories
                                    </router-link>
                                </div>
                            </div>

                            <router-link v-if="me.id != -1 && me.subscription && !me.subscription.expired" class="navbar-item" v-bind:class="{'is-selected' : routeMatch('/dashboard/stats')}" to="/dashboard/stats">
                                <div class="level-item has-text-centered">
                                    <div>
                                        <p class="heading"><i class="fa fa-2x fa-chart-line"></i></p>
                                        <p class="heading">Achievements</p>
                                    </div>
                                </div>
                            </router-link>

                            <router-link v-if="me.id != -1 && me.subscription && !me.subscription.expired" class="navbar-item" v-bind:class="{'is-selected' : routeMatch('/dashboard/news')}" to="/dashboard/news">
                                <div class="level-item has-text-centered">
                                    <span v-bind:data-badge="news.length" :class="{ 'is-badge-danger is-badge-small badge': news.length > 0}">
                                        <p class="heading" ><i  class="fa fa-2x fa-bell" :class="{ 'bell-shake-delay': news.length > 0}" ></i></p>
                                        <p class="heading">News</p>
                                    </span>
                                </div>
                            </router-link>
<!--                                <div class="navbar-dropdown">

                                    <a v-for="(n, index) in me.news" key="index" class="navbar-item"  @click="removeNews(index, n.id)">
                                        <span class="margin-right-10">{{ n.title }}</span><i v-if="n.pivot.seen == 0" data-badge=" New " class="is-badge-danger is-badge-small badge is-pulled-right" ></i>
                                    </a>
                                    <hr class="navbar-divider">
                                    <router-link class="navbar-item" to="/dashboard/news">
                                        See all
                                    </router-link>
                                    </a>
                                </div>-->

                            <div class="navbar-item has-dropdown is-hoverable" v-bind:class="{'is-selected' : routeMatch('/dashboard/profile')}">
                                <router-link class="navbar-link" to="/dashboard/profile">
                                    <img v-if="me.profile && me.profile.avatar" class='round' :src="axios.defaults.storageURL + me.profile.avatar">
                                    <img v-else class='round' src="../static/img/user.png">
                                </router-link>
                                <div v-if="me.id != -1" class="navbar-dropdown">
                                    <router-link v-scroll-to="'#title'" class="navbar-item" to="/dashboard/profile">
                                        <i class="fa fa-user"></i> <span style="margin-left: 10px"> Profile</span>
                                    </router-link>
                                    <a class="navbar-item"  target="_blank" href="https://shop.spreadshirt.com/blabla-commentz-shop/">
                                        <i class="fa fa-shopping-bag"></i> <span style="margin-left: 10px"> Shop</span>
                                    </a>
                                    <router-link v-if="hasMEAsSchool" v-scroll-to="'#title'" class="navbar-item" to="/stby/me">
                                        <i class="fa fa-gift"></i> <span style="margin-left: 10px">Magic Ears StandBy LifeSaver 2.0</span>
                                    </router-link>
<!--                                    <router-link v-if="hasVKAsSchool" v-scroll-to="'#title'" class="navbar-item" to="/stby/vk">
                                        <i class="fa fa-gift"></i> VIPKID Collaborative Lesson Bank
                                    </router-link>-->

                                    <hr class="navbar-divider">
                                    <a class="navbar-item" href="javascript:{}" @click="logout()">
                                        <i class="fa fa-power-off"></i> Logout
                                    </a>
                                </div>
                                <div v-else class="navbar-dropdown">
                                    <router-link v-scroll-to="'#title'" class="navbar-item" to="/register">
                                        Register
                                    </router-link>
                                    <router-link v-scroll-to="'#title'" class="navbar-item" to="/login">
                                        Login
                                    </router-link>
                                </div>
                            </div>
                        </div>

                        <div v-if="isSTBY && (me.id == -1 || me.id == null)"class="navbar-end">
                            <div class="navbar-item">

                                <div class="buttons">
                                    <a href="/login" class="button is-rounded">
                                        I already have an account
                                    </a>
                                    <a href="/register" class="button is-primary is-rounded">
                                        Sign up for Feedback Assistant
                                    </a>
                                </div>


                            </div>
                        </div>
                    </div>

                </nav>
            </div>
        </nav>

        <div class="column is-10-fullhd is-offset-1-fullhd is-12-mobile is-12-tablet">
            <div class="notification is-primary has-text-centered" v-if="!loading && me.id == -1">
                <router-link to="/register"><b>Click here to try the Feedback Assistant and save time with your Feedback reports</b></router-link>
            </div>
            <div class="notification is-primary has-text-centered" v-if="me.id != -1 && me.subscription.subscription_plan_id == null && !me.subscription.expired">
                Thank you for registering your Trial Account, to select a subscription plan please visit the <router-link to="/dashboard/profile"><b>Profile page</b></router-link>. If you have any questions please send us a <router-link to="/dashboard/ticket"><b>Support Ticket</b></router-link>
            </div>

            <div class="notification is-warning has-text-centered" v-if="me.id != -1 && (!me.profile || !me.profile.school)">
                <!--You haven't choosen yet your school. In order to unlock all features of BlaBla Commentz, go to <router-link to="/dashboard/profile"><b>Profile</b></router-link> page and do it now!-->
                To access the lesson and student database please select your school(s) from the <router-link to="/dashboard/profile"><b>Profile page</b></router-link>
            </div>
            <!--<div class="notification is-danger has-text-centered" v-if="me.id != -1 && me.subscription.offer_extend && me.subscription.subscription_plan_id === null && me.subscription.expired">-->
            <div class="notification is-danger has-text-centered" v-if="me.id != -1 && me.subscription.expired"><!--(me.subscription.expired || me.subscription.status == 'trialing' || me.subscription.status == 'past_due' || me.subscription.status == 'deleted')-->
                Your trial period has expired, please visit the <router-link to="/dashboard/profile"><b>Profile page</b></router-link> and select your subscription plan
            </div>
            <transition name="fade">
                <router-view></router-view>
            </transition>

            <news-modal v-if="alerts && alerts.length > 0" :show="showAlertsModal" :news="alerts" @onClose="showAlertsModal = false"></news-modal>
        </div>

        <div class="columns" style="min-height: 100px;">
            <div class="column"></div>
        </div>

        <footer class="footer has-shadow fix-footer is-hidden-mobile">
          <div class="container">
              <div class="content has-text-centered">
                  <div class="columns is-vcentered" >
                      <div class="column is-4 has-text-left">
                          <div class="columns">
                              <div class="column is-12">
                                  <router-link to="/dashboard/terms"><u>Terms and Conditions</u></router-link>
                                  <span class="has-text-primary">|</span>
                                  <router-link to="/dashboard/ticket"><u>Contact us</u></router-link>
                                  <span class="has-text-primary">|</span>
                                  <router-link to="/dashboard/privacy"><u>Privacy policy</u></router-link>
                              </div>
	                      </div>
                      </div>
                      <div class="column is-4 has-text-centered">
                          <!--<b><span class="has-text-primary">Follow Us</span></b>-->
	                      <div class="column">
		                      <a href="https://www.facebook.com/BlaBla-Commentz-ESL-Feedback-Assistant-100642284743216/" target="_blank" ><i class="icon-facebook fab fa-facebook-f fa-2x" aria-hidden="true"></i></a>
		                      <a href="https://twitter.com/BlaBla_Commentz" target="_blank" ><i class="icon-twitter fab fa-twitter fa-2x" aria-hidden="true"></i></a>
		                      <a href="https://www.instagram.com/blablacommentz/" target="_blank" ><i class="icon-instagram fab fa-instagram fa-2x" aria-hidden="true"></i></a>
		                      <a href="https://www.youtube.com/channel/UCuxsSXR2N_QoxXvdbHYqvgQ" target="_blank" ><i class="icon-youtube fab fa-youtube fa-2x" aria-hidden="true"></i></a>
		                      <!--<a href="#" ><i class="icon-linkedin fab fa-linkedin" aria-hidden="true"></i></a>-->
	                      </div>

                      </div>
                      <div class="column is-4 has-text-right">
                          <b>Copyright © {{new Date().getFullYear()}} <span class="has-text-primary">BlaBla Commentz</span></b>
                      </div>
                  </div>
              </div>
          </div>
        </footer>
    </div>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
import NewsModal from './components/news/NewsModal'
export default {
    name: 'dashboard',
    components: {NewsModal},
    mixins : [global],
    data(){
      return {
          me: {
            profile: {}
          },
          loading:true,
          news : [],
          alerts: [],
          showAlertsModal: false,
      }
    },
    created(){

        let md = new MobileDetect(window.navigator.userAgent);
        if(md.mobile()){
          this.$swal({
            type: 'error',
            confirmButtonText:  'I understand <i class="far fa-thumbs-up"></i>',
            focusConfirm: false,
            confirmButtonColor: '#f27474',
            text: 'This application is not intended for use on mobile phones!',
          });
        }
        let self = this;

        if(this.$me.id != -1) {

            this.me = this.$me;
            if(this.me.news && this.me.news.length > 0) {
                let alerts = this.me.news.filter(item => (item.pivot.seen == 0 && item.type == 'alert'));
                this.alerts = alerts ? alerts : this.alerts;
                let news = this.me.news.filter(item => (item.pivot.seen == 0 && item.type != 'alert'));
                this.news = news ? news : this.news;

                if(this.alerts && this.alerts != undefined && this.alerts.length > 0){
                    this.showAlertsModal = true;
                }
            }

            if(this.me.subscription.expired){
                self.$router.push('/dashboard/profile');
            }
            else {
                this.initialRedirects();
            }
        }
        else if(this.$auth.getToken()){
                this.userRepo.me().then(response => {
                    Vue.prototype.$me = response.data.data;
                    this.me = this.$me;
                    this.loading = false;
                    if(this.me.news) {
                        let alerts = this.me.news.filter(item => (item.pivot.seen == 0 && item.type == 'alert'));
                        this.alerts = alerts ? alerts : this.alerts;
                        let news = this.me.news.filter(item => (item.pivot.seen == 0 && item.type != 'alert'));
                        this.news = news ? news : this.news;
/*
                        _.where(this.me.news, function (n) {
                            if (n.pivot.seen == 0) {
                                if (n.type == 'alert') {
                                    self.alerts.push(n);
                                }

                                self.news.push(n);
                            }
                        });
*/
                        if (this.alerts && this.alerts != undefined && this.alerts.length > 0) {
                            this.showAlertsModal = true;
                        }

                    }
                    if(this.isSTBY){
                        this.loading = false
                    }
                    else if(this.me.subscription.expired){
                        self.$router.push('/dashboard/profile');
                    }
                    else {
                        this.initialRedirects();
                    }
                }).finally(() => {
                    //localStorage.removeItem(this.$auth.options.storageNamespace + '.' + this.$auth.options.tokenPrefix  + '_' + this.$auth.options.tokenName);
                    this.loading = false
                });

        }else{
            if(this.isSTBY){
                this.loading = false
            }
            else {
                this.initialRedirects();
            }
        }





    },
    mounted(){


            // Get all "navbar-burger" elements
            var $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

            // Check if there are any navbar burgers
            if ($navbarBurgers.length > 0) {

                // Add a click event on each of them
                $navbarBurgers.forEach(function ($el) {
                    $el.addEventListener('click', function () {

                        // Get the target from the "data-target" attribute
                        var target = $el.dataset.target;
                        var $target = document.getElementById(target);

                        // Toggle the class on both the "navbar-burger" and the "navbar-menu"
                        $el.classList.toggle('is-active');
                        //$el.classList.toggle('is-hidden');
                        $target.classList.toggle('is-active');
                        //$target.classList.toggle('is-hidden');
                    });
                });
            }

    },
    methods: {
        initialRedirects(){
            if(!this.me.profile || !this.me.profile.school){
                this.$router.push('/dashboard/profile');
            }
            else if(this.news && this.news.length > 0){
                //this.$router.push('/dashboard/news');
            }
        },

        closeMenu(){
            // Get all "navbar-burger" elements
            var $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

            // Check if there are any navbar burgers
            if ($navbarBurgers.length > 0) {

                // Add a click event on each of them
                $navbarBurgers.forEach(function ($el) {

                        // Get the target from the "data-target" attribute
                        var target = $el.dataset.target;
                        var $target = document.getElementById(target);

                        // Toggle the class on both the "navbar-burger" and the "navbar-menu"
                        $el.classList.remove('is-active');
                        //$el.classList.toggle('is-hidden');
                        $target.classList.remove('is-active');
                        //$target.classList.toggle('is-hidden');
                });
            }
        },
        redirectTo(to){
            this.closeMenu();
            this.$router.push(to);
        },
        logout: function () {
            let component = this;
            this.$auth.logout().then(function () {
                component.$router.push('/');
            }).catch(function(){
                component.$router.push('/');
            }).finally(function() {
                Vue.prototype.$me = {
                    price: 0,
                    user: {
                        profile: {
                            name: ''
                        },
                        news : [],
                        unseenNews :[]
                    },
                    id: -1
                };
            });

        },
        routeMatch(path){
            return this.$route.path.startsWith(path);
        },
        removeNews(id, redirect = true){
            for (var i = 0; i < this.news.length; i++) {
                if (this.news[i].id == id) {
                    this.news.splice(i, 1);
                }
            }
            _.where(this.me.news, function(n) {
                if(n.id == id){
                    n.pivot.seen = 1;
                }
            });
            if(redicrect) {
                this.$router.push('/dashboard/news/' + id);
            }
        }
  },
    watch: {
        'newsCount':function(value){

        }
    },
    computed: {
        hasMEAsSchool () {
            if(this.me != -1 && this.me.profile != null && this.me.profile.schools != null && this.me.profile.schools.length != 0){
                return this.me.profile.schools.some((item) => { return item.id == 1/*ME ID*/});
            }
        },
        hasVKAsSchool () {
            if(this.me != -1 && this.me.profile != null && this.me.profile.schools != null && this.me.profile.schools.length != 0){
                return this.me.profile.schools.some((item) => { return item.id == 3/*ME ID*/});
            }
        },

        isSTBY(){
            return this.$router.history.current.path.includes("/stby");
        },

    }
}
</script>

<style scoped>
    .divider{
        position:absolute;
        left:50%;
        top:10%;
        bottom:10%;
        border-left:1px solid white;
    }
.navbar{
    margin-bottom: 10px !important;
    border: none;
}
.navbar.columns{
    padding: 5px;
}

.navbar .hero-body{
    padding: 0px;
    padding-top: 10px;
    padding-left: 5px;
}
.menu{
    padding-left: 5px;
    padding-right: 1px;
}
.collapse-item{
    z-index: 19;
}

.is-rounded{
    border-radius: 290486px;
    padding-left: 1em;
    padding-right: 1em;
}

.fix-footer{
    z-index: 100;
}

.fa-power-off {
    margin-right: 5px;
}
figure.avatar{
    width: max-content;
}

nav{
    background-color: #3D4351 !important;
}
.margin-right-10{
    margin-right: 10px;
}

.navbar-item {
    padding: 0.5rem 1rem;
}

.navbar-item .logo{
    max-height: 4.25rem;
    margin-right: 1rem;
}

.navbar-item .header{
    max-height: 3.25rem;
}

.navbar-link{
    padding: 0rem 1rem;
    padding-top: 0.5rem;
}

.navbar-item img {
    max-height: 3.75rem;
}

.navbar-item div, navbar-item .navbar-link{
    color: white;
    min-width: 65px;

}

.navbar-item.is-selected{
    border-bottom: 4px solid #00d1b2;
    margin-bottom: -1px;
}

nav .subtitle{
    color:white;
}

/*nav a.navbar-item{
color: #00d1b2;
}*/

nav a.navbar-item:hover{
color: #00d1b2;
}
nav .navbar-item.has-dropdown a::after{
    border: none;
}

nav .navbar-item.has-dropdown .navbar-link{
    padding: 0px !important;
}
/*
nav .navbar-item.has-dropdown:hover{
    background-color: #292929;
    color: #ddd;
}*/


nav .navbar-item.has-dropdown{
    padding: 0.5rem 1rem;
}

nav .navbar-end{
    margin-left: -146px;
}
</style>



// WEBPACK FOOTER //
// src/Dashboard.vue